import type { DocsPageTranslation } from './types'

// Initial LLM-assisted Arabic docs translation. Localization team should review
// before release; source_en_hash marks the English source revision used here.
export const DOCS_PAGE_TRANSLATIONS_AR: Record<string, DocsPageTranslation> = {
  'account/profile': {
    source_en_hash: 'v1:19bd8xdwqco',
    title: 'الملف الشخصي',
    description: 'اسمك المستعار وبريدك الإلكتروني.',
    overview: `يعرّفك اسمك المستعار عبر Martini: مؤشرات المشاريع، والتعاون، وقائمة الحساب. يُستخدم بريدك الإلكتروني لتسجيل الدخول، وإيصالات الفوترة، ودعوات الفريق.

حدّث ملفك الشخصي من صفحة إعدادات الحساب.`,
  },
  'account/preferences': {
    source_en_hash: 'v1:19yltxzw1cu',
    title: 'التفضيلات',
    description: 'النماذج المخفية وإعدادات سير العمل.',
    overview: `أخفِ النماذج التي لا تستخدمها من لوحة التوليد. التفضيلات مرتبطة بالحساب وتنتقل معك عبر المشاريع والفرق.

إذا كنت تستخدم Veo وKling فقط، فأخفِ البقية. تصبح لوحة التوليد أنظف، ولن تضطر إلى التمرير عبر نماذج لن تختارها أبدًا.`,
  },
  'account/billing': {
    source_en_hash: 'v1:s6ohjzhuxy',
    title: 'الفوترة',
    description: 'الخطط، وolives، والمعاملات، والفواتير.',
    overview: `اعرض خطتك الحالية، ورصيد olives، وسجل المعاملات من صفحة الفوترة. يمكنك الترقية أو الرجوع إلى خطة أدنى أو إضافة رصيد في أي وقت. يمكنك أيضًا تنزيل الفواتير.

تُظهر تفاصيل الإنفاق التكلفة حسب المشروع حتى تعرف أين ذهبت olives. إذا كنت ضمن فريق، ففوترة الفريق تُدار بشكل منفصل بواسطة مشرف الفريق.`,
  },
  'canvas/overview': {
    source_en_hash: 'v1:24twlaut3dj',
    title: 'نظرة عامة',
    description: 'مساحة العمل اللامحدودة التي يعيش فيها كل شيء.',
    overview: `الكانفاس مساحة عمل ثنائية الأبعاد لا محدودة. يعيش مشروعك هنا: اللقطات، والصور، والصوت، والمجموعات، والتعليقات النصية. لا توجد صفحات أو مجلدات للتنقل بينها. تنظّم عملك مكانيًا، كما لو كنت ترتّب الاختيارات على طاولة إضاءة أو المراجع على جدار.

يتبع كل كائن على الكانفاس القواعد نفسها للتحديد، والتحريك، والتنظيم. ابتعد بالتكبير لرؤية المشروع كاملًا أو اقترب لتفقد إطار. مرّر للتكبير، واسحب بإصبعين للتحريك، واضغط ||F|| لملاءمة كل شيء داخل العرض.`,
  },
  'canvas/nodes': {
    source_en_hash: 'v1:1wj9a4wqesi',
    title: 'كائنات الكانفاس',
    description: 'كل نوع من الكائنات التي يمكنك وضعها على الكانفاس.',
    overview: `اضغط اختصارًا للدخول في وضع placement، ثم انقر على الكانفاس لوضع الكائن. استخدم ||V|| للقطات الفيديو، و||I|| للصور، و||T|| للتعليقات النصية، و||B|| للحاويات، و||Shift V|| للمتغيرات، و||Shift S|| للمجموعات، و||A|| للصوت.

لكل نوع وظيفة. اللقطات والصور تحمل مادة بصرية. مجموعات المكتبة (Library) تحافظ على اتساق الشخصيات والدعائم عبر المشاريع. المتغيرات تخزّن أجزاء مطالبات قابلة لإعادة الاستخدام. الحاويات تجمع العمل المرتبط. التعليقات ملاحظات لك أو للمتعاونين. المجموعات بيئات ثلاثية الأبعاد يمكنك توليد لقطات منها.`,
  },
  'canvas/selection': {
    source_en_hash: 'v1:aigbiuhqie',
    title: 'التحديد',
    description: 'انقر، وShift+انقر، واسحب مستطيلًا لتحديد العمل على الكانفاس.',
    overview: `انقر للتحديد. استخدم ||Shift||+انقر للإضافة إلى التحديد. اسحب عبر مساحة فارغة للتحديد بمستطيل. يحدد ||⌘A|| كل شيء. يمسح ||Escape|| التحديد.

تُظهر الكائنات المحددة إطارًا. يتيح لك التحديد المتعدد تحريك عدة كائنات أو حذفها أو وسمها في وقت واحد. يعرض المفتش تفاصيل آخر كائن تم تحديده.

اسحب كائنًا لتحريكه دون تغيير محتواه. إذا كانت عدة كائنات محددة، فإن سحب أي واحد منها يحرّك التحديد بالكامل مع الحفاظ على مواضعها النسبية.`,
  },
  'canvas/organizing': {
    source_en_hash: 'v1:28jlsrfkc2l',
    title: 'التنظيم',
    description: 'تسميات الألوان، والتقييمات، والحاويات، والفلاتر.',
    overview: `اضغط ||1|| إلى ||5|| لتطبيق تسمية لون. يضع ||F|| علامة مفضلة. يضع ||R|| علامة رفض. هذه أدوات الفرز التي يستخدمها المحررون عند انتقاء اللقطات من dailies: تعليم اللقطات القوية، ورفض الضعيفة، وفرز ما تبقى.

اضغط ||B|| لإنشاء حاوية، ثم اسحب اللقطات إليها لتجميعها على الكانفاس. الحاويات ليست مجلدات؛ يبقى كل شيء مرئيًا ويمكن الوصول إليه. اضغط ||Shift F|| لفتح الفلاتر حسب المفضلات، أو المرفوضات، أو تسمية لون محددة. الفلاتر تغيّر فقط ما تراه.`,
  },
  'canvas/clipboard': {
    source_en_hash: 'v1:19nz99iz0ro',
    title: 'النسخ، واللصق، والتكرار',
    description: 'عمليات الحافظة والتكرار السريع.',
    overview: `ينسخ ||⌘C||، ويلصق ||⌘V||، ويكرر ||⌘D||. تُلصق الكائنات المنسوخة قرب الأصل مع الاحتفاظ بإعداداتها. يكون ||⌘D|| أسرع عندما تريد نسخة فورية بدون استخدام الحافظة.

تعمل هذه العمليات على كائن واحد أو تحديد متعدد. انسخ خمس لقطات، والصقها في جزء آخر من الكانفاس، وستحتفظ بمواضعها النسبية.`,
  },
  'canvas/undo-redo': {
    source_en_hash: 'v1:19hh43keqnm',
    title: 'التراجع والإعادة',
    description: 'عكس إجراءات الكانفاس واستعادتها.',
    overview: `يتراجع ||⌘Z|| عن آخر إجراء. ويعيده ||⌘ Shift Z||. يغطي التراجع عمل الكانفاس مثل التحريك، والحذف، وإعادة التسمية، وإنشاء الكائنات.

التراجع واعٍ بالتعاون. إنه يعكس إجراءاتك أنت، لا إجراءات المتعاونين. إذا حرّك شخص آخر عقدة أثناء عملك، فلن يتراجع ||⌘Z|| عن حركته.`,
  },
  'canvas/rename': {
    source_en_hash: 'v1:glr66svv1q',
    title: 'إعادة التسمية',
    description: 'أعد تسمية العمل مباشرة على الكانفاس.',
    overview: `حدد كائنًا واضغط ||Enter|| لإعادة تسميته مباشرة. اكتب الاسم الجديد واضغط ||Enter|| مرة أخرى للتأكيد، أو ||Escape|| للإلغاء. تظهر الأسماء أسفل الكائنات على الكانفاس وتساعد في التعرف على اللقطات عندما تعمل مع الكثير من النسخ.`,
  },
  'canvas/delete': {
    source_en_hash: 'v1:8fw602mwuu',
    title: 'الحذف',
    description: 'إزالة العمل من الكانفاس.',
    overview: `اضغط ||Delete|| أو ||Backspace|| لإزالة الكائنات المحددة. يعمل هذا على كائن واحد أو تحديد متعدد. الحذف قابل للتراجع؛ يعيد ||⌘Z|| العمل.`,
  },
  'canvas/playback': {
    source_en_hash: 'v1:1xs0lrqf04s',
    title: 'التشغيل',
    description: 'معاينة اللقطات والتنقل داخل الفيديو.',
    overview: `يشغّل ||Space|| ويوقف مؤقتًا. تستخدم ||J||/||K||/||L|| للتنقل: يشغّل ||J|| للخلف، ويشغّل ||L|| للأمام، ويوقف ||K||. اضغط ||L|| مرتين للسرعة المضاعفة. تطابق عناصر التحكم Premiere وAvid وDaVinci.

حدد لقطة واضغط ||Space|| لمعاينتها في مكانها على الكانفاس. تعرض شاشة البرنامج أعلى الجدول الزمني الإطار الحالي بحجم أكبر.`,
  },
  mcp: {
    source_en_hash: 'v1:1hqksqxtlfe',
    title: 'إعداد MCP',
    description: 'وصّل وكلاء متوافقين مع MCP بمشاريع Martini.',
    overview: `يحتوي Martini على خادم MCP مدمج يتيح للوكلاء العمل داخل مشاريعك. وصّل Claude أو Cursor أو أدواتك الخاصة لقراءة حالة المشروع، وإنشاء كائنات على الكانفاس، وتشغيل عمليات التوليد، وإدارة الكانفاس.

أعدّه مرة واحدة، ثم أتمت مهام الإنتاج من أي وكيل متوافق مع MCP.`,
  },
  'export/overview': {
    source_en_hash: 'v1:107qvtix405',
    title: 'نظرة عامة',
    description: 'إخراج عملك من Martini.',
    overview: `التصدير هو طريقة إخراج عملك من Martini. صدّر MP4 لفيديو مستقل، أو صدّر حزمة XML للإكمال في Premiere أو DaVinci Resolve أو CapCut. تتضمن حزمة XML ملفات الوسائط وبنية الجدول الزمني، حتى تتمكن من فتحها في محرر ومتابعة العمل.

يعتمد التنسيق على الوجهة التالية للمشروع. MP4 للمراجعات والتسليمات. XML لما بعد الإنتاج.`,
  },
  'export/mp4': {
    source_en_hash: 'v1:17a7qgub68u',
    title: 'MP4',
    description: 'تصدير فيديو مباشر.',
    overview: `صدّر إلى MP4 عندما تحتاج إلى ملف فيديو مستقل. اختر الدقة والجودة، ثم ابدأ التصيير. يتضمن الناتج كل لقطات الجدول الزمني بالترتيب، مع نقاط القص الحالية.

مناسب للنسخ الأولية، ومراجعات العملاء، أو وسائل التواصل الاجتماعي: أي حالة يكون فيها الفيديو هو التسليم النهائي.`,
  },
  'export/nle': {
    source_en_hash: 'v1:1wma3l4cdj8',
    title: 'تصدير XML',
    description: 'التصدير إلى Premiere وDaVinci وCapCut.',
    overview: `صدّر حزمة XML عندما تريد الإكمال في Premiere Pro أو DaVinci Resolve أو CapCut. تحمل الحزمة الوسائط، والمسارات، والتوقيت من جدول Martini الزمني.

استخدم XML للمشاريع التي تحتاج إلى تصحيح ألوان، أو تصميم صوت، أو إنهاء VFX. يحمل XML قائمة قرارات المونتاج. ويحمل مجلد الوسائط اللقطات.`,
  },
  'generation/overview': {
    source_en_hash: 'v1:65l7fbi17r',
    title: 'نظرة عامة',
    description: 'كيف يعمل التوليد بالذكاء الاصطناعي في Martini.',
    overview: `يتصل Martini بعدة نماذج ذكاء اصطناعي: Veo وKling وSora وغيرها. لا تحتاج إلى حسابات منفصلة أو مفاتيح API. اختر نموذجًا، واكتب مطالبة، واضبط المعلمات، وولّد. يظهر كل ناتج على الكانفاس حتى تتمكن من التكرار، أو التقييم، أو إدخاله في الجدول الزمني.

التوليد هو الحلقة الأساسية. ضع لقطة، وصف ما تريد، واختر نموذجًا، ثم ولّد. إذا لم تكن النتيجة مناسبة، عدّل وأعد التوليد. يمنحك الكانفاس مساحة لمقارنة النسخ جنبًا إلى جنب.`,
  },
  'generation/images': {
    source_en_hash: 'v1:2400a89jp95',
    title: 'الصور',
    description: 'ولّد إطارات ثابتة واستخدم المراجع.',
    overview: `غالبًا ما يكون توليد الصور نقطة البداية. ولّد إطارًا ثابتًا، ثم استخدمه كمرجع لتوليد الفيديو. يمكنك أيضًا رفع صور، أو storyboards، أو concept art واستخدامها كإطارات بداية أو مراجع أسلوب.

تحافظ مجموعات المكتبة على اتساق الشخصيات والدعائم عبر اللقطات من خلال ربط النموذج بهوية بصرية محددة. احفظ أوضح الصور في مجموعة، واستدعِها بـ @ في المطالبة، وستحافظ كل لقطة تستدعيها على ذلك المظهر.`,
  },
  'generation/video': {
    source_en_hash: 'v1:1smga0lwpzx',
    title: 'الفيديو',
    description: 'ولّد لقطات متحركة من المطالبات والمراجع.',
    overview: `يحوّل توليد الفيديو مطالبة إلى لقطة متحركة. أضف إطار بداية، أو إطار نهاية، أو صورة مرجعية عندما تحتاج إلى مزيد من التحكم. تدعم النماذج المختلفة أدوات تحكم مختلفة. يقبل بعضها إطارات بداية ونهاية لحركة كاميرا دقيقة؛ ويعمل بعضها الآخر بشكل أفضل من النص وحده.

تعتمد المدة، والدقة، ونسبة العرض إلى الارتفاع على النموذج. يحافظ Martini على اتساق الواجهة حتى تتمكن من تحديد النية ومعرفة المعلمات التي يقبلها كل نموذج.`,
  },
  'generation/models': {
    source_en_hash: 'v1:1zivmdgst0h',
    title: 'النماذج',
    description: 'متى تستخدم Veo وKling وSora وغيرها.',
    overview: `لكل نموذج نقاط قوة. يتعامل Veo مع التحكم بالكاميرا وتكوين إطاري البداية والنهاية. Kling سريع وقوي في الحركة. لدى Sora مظهر سينمائي مميز. يعمل Wan جيدًا مع المحتوى الأسلوبي. يولّد Ray الصور والفيديو معًا.

يعرض منتقي النماذج ما يدعمه كل نموذج: توليد فيديو، أو توليد صور، أو الاثنين معًا. لا يقبل كل نموذج كل المعلمات. اختر النموذج الذي يناسب اللقطة، لا النموذج صاحب أكبر عدد من الميزات. يمكنك إخفاء النماذج التي لا تستخدمها من التفضيلات.`,
  },
  'generation/prompting': {
    source_en_hash: 'v1:xyd9da5qjl',
    title: 'كتابة المطالبات',
    description: 'اكتب مطالبات تنتج نتائج سينمائية.',
    overview: `المطالبات توجيهات، وليست أوصافًا. اكتب ما قد تقوله لمدير تصوير أو مشرف VFX: حركة الكاميرا، والإضاءة، والإيقاع، وإحساس اللقطة. اللغة المحددة والملموسة تعمل أفضل من التعليمات المجردة.

"لقطة تتبع محمولة باليد، ضوء طبيعي عبر نافذة، الشخص يستدير ببطء" أقوى من "لقطة سينمائية جميلة لشخص". سمّ حركة الكاميرا، ومصدر الضوء، والفعل. تجنّب صفات مثل "مذهل" أو "خاطف للأنفاس"؛ فهي لا تتحول إلى تعليمات واضحة للنموذج.

قبل إعادة التوليد، غيّر جزءًا مهمًا واحدًا من المطالبة في كل مرة. هذا يجعل رؤية ما تحسّن في اللقطة أسهل.`,
  },
  'generation/upscaling': {
    source_en_hash: 'v1:1th5x70ufdk',
    title: 'رفع الدقة',
    description: 'رفع الدقة، أو تحسين التفاصيل، أو التحويل إلى HDR.',
    overview: `يرفع التحسين (Upscale) دقة اللقطة بعد اكتمالها، ويمكنه أيضًا إبراز التفاصيل أو تحويلها إلى HDR. يعمل على الفيديو والصور معًا. حدّد اللقطة أو الصورة واختر Upscale & Enhance — من قائمة النقر بالزر الأيمن، أو من لوحة الخصائص، أو بالضغط على ||U||.

![](/docs-imgs/generationUpscale.mp4)

Source: النسخة التي ستعمل عليها من اللقطة، وهي عادةً النسخة الأصلية. انقر على أيقونة المعلومات لرؤية تفاصيل النسخة الأصلية — أبعادها ونوع الملف ووقت إنشائها ومعرّف الأصل الخاص بها.

Preset: حزمة محفوظة تضم كل الإعدادات الواردة أدناه — النموذج والدقة والجودة والترميز وما إلى ذلك — محفوظة تحت اسم معيّن. يعني Custom أنك تضبط كل شيء يدويًا؛ وبمجرد أن تصل إلى تركيبة تعجبك، انقر على علامة الزائد لحفظها كإعداد مسبق باسم محدد وإعادة استخدامها لاحقًا. تُشارَك الإعدادات المسبقة مع فريقك، فيمكن أن يبقى المشروع بأكمله على المظهر والمواصفات نفسها.

Operation: يزيد Upscale الدقة والتفاصيل؛ ويعمل Enhance على إزالة التشويش والضبابية واستعادة الصورة؛ ويُخرج HDR ملفًا بنطاق ديناميكي عالٍ بعمق 10-bit أو 16-bit.

Model: المحرك الذي يقوم بالعمل. تناسب النماذج العامة مثل Proteus معظم اللقطات، وتستهدف نماذج التفاصيل والتصحيح الحدّة أو مشكلات بعينها، وتمنحك عائلة Starlight أعلى جودة. ولتحسين الصور نماذج خاصة بها سريعة وتوليدية.

Resolution: حجم الإخراج المستهدف، من HD حتى 8K. يعرض Martini معامل التكبير (مثل 4x) والحد الأقصى الذي يسمح به كل ترميز.

Quality: مقدار ما يقوم به النموذج من تنظيف للصورة وزيادة لحدّتها. وهي تلقائية افتراضيًا — يختار Martini إعدادات مناسبة لك — ولا تضيف أدوات التحكم اليدوية (التفاصيل، التشويش، الضبابية، الحُبيبات، الضغط) إلا عندما تريد تحكمًا مباشرًا في المظهر.

Output: الترميز هو الصيغة التي تُحفظ بها النتيجة — H.265 أو H.264 أو AV1، إضافةً إلى صيغ التسليم HDR وProRes. ويوازن الضغط بين حجم الملف والجودة: تحافظ Low على أكبر قدر من التفاصيل في ملف أكبر حجمًا، بينما تفعل High العكس.

Frame rate: عدد الإطارات التي تُعرض في كل ثانية؛ كلما ارتفع المعدل بدا العرض أكثر سلاسة. يحافظ Auto على معدل الفيديو المصدر، أو اضبط معدلًا مخصصًا مثل 24 أو 30 أو 60 fps.

تظهر النتيجة كنسخة جديدة ضمن المجموعة نفسها، فيمكنك التبديل بين النسخة الأصلية والنسخة المُحسَّنة للمقارنة بينهما.

تعتمد التكلفة بوحدة olives على النموذج وحجم الإخراج: تُحتسب تكلفة الفيديو لكل ثانية من الإخراج، والصور لكل ميغابكسل، وتكلّف النماذج الأعلى جودة مثل Starlight أكثر.

![](/docs-imgs/upscale.png)`,
  },
  'generation/credits': {
    source_en_hash: 'v1:101i5vr0a9y',
    title: 'Olives',
    description: 'كيف يعمل إنفاق التوليد.',
    overview: `Olives هي وحدة الإنفاق في Martini. كل عملية توليد تكلف olives. تعتمد الكمية على النموذج، والدقة، والمدة. رصيدك ظاهر في قائمة الحساب.

عندما ينفد رصيدك، يمكنك إضافة رصيد أو ترقية خطتك. إذا فشلت عملية توليد، يعيد Martini olives تلقائيًا. تعرض صفحة النماذج المدعومة تكلفة كل نموذج حتى تتمكن من التخطيط قبل التوليد.`,
  },
  'getting-started/welcome': {
    source_en_hash: 'v1:1ehqbgkba04',
    title: 'مرحبًا',
    description: 'ما هو Martini وكيف يستخدمه صنّاع الأفلام.',
    overview: `Martini هو موقع تصوير لفيديو الذكاء الاصطناعي. تعمل على كانفاس لامحدود: تضع اللقطات، وتولّد باستخدام نماذج الذكاء الاصطناعي، وتكرر حتى تصل النتيجة، ثم تجمع كل شيء على جدول زمني. صُمم للتكرار السريع، والتنظيم المكاني، والتعاون في الوقت الفعلي.

![](/docs-imgs/welcome1.mp4)

اضغط ||V|| لوضع لقطة. اكتب مطالبة، واختر نموذجًا، وولّد. إذا لم تكن النسخة مناسبة، فعدّل المطالبة، أو بدّل صورة المرجع، أو جرّب نموذجًا آخر. تبقى كل نسخة جديدة بجانب الأصل حتى تتمكن من المقارنة.

![](/docs-imgs/welcome2.mp4)

عندما تحصل على اللقطات التي تريدها، اسحبها إلى الجدول الزمني وصدّر. يدعم Martini نماذج Veo وKling وSora وغيرها من خلال واجهة واحدة، حتى تتمكن من اختيار النموذج الذي يناسب اللقطة.`,
  },
  'getting-started/first-shot': {
    source_en_hash: 'v1:1516v8f2dr5',
    title: 'لقطتك الأولى',
    description: 'ولّد صورة، ثم حوّلها إلى فيديو.',
    overview: `يبدأ كل مشروع بكانفاس فارغ. اضغط ||V|| لوضع لقطة، واكتب مطالبة، واختر نموذجًا، وولّد. هذا هو سير العمل الأساسي. أما الباقي فهو التكرار.

يدعم Martini توليد صورة إلى فيديو، وفيديو إلى فيديو، ونص إلى فيديو. اختر النهج الذي يناسب اللقطة. يبدأ كثير من صنّاع الأفلام بصورة مولّدة أو مرفوعة، ثم يستخدمونها كإطار بداية للفيديو. تثبت الصورة التكوين؛ ويتولى النموذج الحركة.`,
  },
  'getting-started/iterating': {
    source_en_hash: 'v1:7e0ld19ccr',
    title: 'تكرار تحسين اللقطات',
    description: 'حسّن اللقطات عبر التكرار السريع.',
    overview: `نادرًا ما تكون أول عملية توليد هي النهائية. أعد كتابة المطالبة، أو بدّل صورة المرجع، أو جرّب نموذجًا مختلفًا، أو عدّل المدة. تهبط كل نسخة بجانب الأصل حتى تتمكن من مقارنتها جنبًا إلى جنب.

بُني Martini حول حلقة بسيطة: ولّد، راجع، عدّل، أعد التوليد. يمنحك الكانفاس مساحة لنشر الخيارات. وتحافظ المكدسات على اللقطات المرتبطة معًا عندما تصقل لقطة واحدة.`,
  },
  'sets/overview': {
    source_en_hash: 'v1:cbl38tqd8g',
    title: 'نظرة عامة',
    description: 'بيئات ثلاثية الأبعاد مبنية من صورة واحدة.',
    overview: `المجموعات بيئات ثلاثية الأبعاد مبنية من صورة واحدة. ارفع أو ولّد صورة مرجعية، ويبني Martini منها مساحة ثلاثية الأبعاد قابلة للتنقل. فكّر في المجموعة كموقع افتراضي. يمكنك تحريك كاميرا داخله، ووضع الشخصيات، وتوليد لقطات من زوايا محددة.

هذا أقرب ما يكون إلى استكشاف المواقع وبناء موقع تصوير فعلي. الموقع نفسه، مواضع كاميرا مختلفة، وجغرافيا متسقة بين اللقطات.`,
  },
  'sets/creating': {
    source_en_hash: 'v1:2enib07kray',
    title: 'إنشاء مجموعة',
    description: 'حوّل صورة إلى مساحة ثلاثية الأبعاد قابلة للتنقل.',
    overview: `ابدأ بصورة مولّدة أو مرفوعة. يبني Martini منها بيئة ثلاثية الأبعاد قابلة للتنقل. تستغرق العملية بضع دقائق.

عندما تكتمل، تظهر المجموعة كعقدة على الكانفاس. انقر نقرًا مزدوجًا لفتح عارض المجموعة والتنقل في المساحة ثلاثية الأبعاد.`,
  },
  'sets/characters': {
    source_en_hash: 'v1:23pqljuiw5c',
    title: 'الشخصيات',
    description: 'اختيار ممثلين متسق عبر اللقطات المبنية على المجموعات.',
    overview: `الشخصيات هويات ثابتة موضوعة داخل مجموعة. ارفع أو ولّد sheet شخصية، وسيكتشف Martini الشكل، ويستخرج الزي، وينشئ مرجعًا قابلًا لإعادة الاستخدام.

عندما تولّد من مجموعة، تظهر الشخصية في المساحة ثلاثية الأبعاد. هذا يحافظ على اتساق الاختيار بين زوايا الكاميرا: الشخص نفسه، والملابس نفسها، وتأطير مختلف.`,
  },
  'sets/viewer': {
    source_en_hash: 'v1:up8l8cp3q2',
    title: 'عارض المجموعة',
    description: 'تنقّل داخل البيئة ثلاثية الأبعاد وحدد مواضع الكاميرات.',
    overview: `عارض المجموعة نافذة عرض ثلاثية الأبعاد مدمجة في الكانفاس. اسحب للدوران، ومرّر للتكبير، واسحب بزر الفأرة الأيمن للتحريك. أنت تحرّك كاميرا افتراضية داخل البيئة.

من أي موضع، يمكنك التقاط screenshot كإطار مرجعي أو توليد لقطة من تلك الزاوية بالضبط. تُدمج موضع الكاميرا، والشخصيات، والبيئة تلقائيًا في مطالبة التوليد.`,
  },
  'teams/overview': {
    source_en_hash: 'v1:1nwl3a18oii',
    title: 'نظرة عامة',
    description: 'مساحات عمل مشتركة للمؤسسات.',
    overview: `الفرق مساحات عمل مشتركة للاستوديوهات والوكالات. يشارك الأعضاء الفوترة، وإعدادات الوصول إلى النماذج، وملكية المشاريع. يتحكم مشرفو الفريق في من يمكنه الانضمام، والنماذج المتاحة، ومقدار ما يمكن لكل عضو إنفاقه.

أنشئ فريقًا من إعدادات حسابك. ادعُ الأعضاء عبر البريد الإلكتروني. المشاريع المنشأة داخل الفريق تكون مرئية لكل الأعضاء وتسحب من رصيد olives الخاص بالفريق.`,
  },
  'teams/members': {
    source_en_hash: 'v1:10exf22pba9',
    title: 'الأعضاء والأدوار',
    description: 'الدعوات والصلاحيات.',
    overview: `ادعُ الأعضاء عبر البريد الإلكتروني. يضيف المشرفون الأعضاء ويزيلونهم، ويعدّلون إعدادات الفريق، ويتحكمون في الإنفاق. يعمل الأعضاء داخل مشاريع الفريق ويسحبون من فوترة الفريق.

عندما يغادر شخص الفريق، تبقى مشاريعه. لا يضيع شيء.`,
  },
  'teams/billing': {
    source_en_hash: 'v1:vbh19d66ga',
    title: 'فوترة الفريق',
    description: 'الفوترة المشتركة وحدود الإنفاق.',
    overview: `تشارك الفرق حساب فوترة واحدًا. تنطبق الخطة على الفريق كله، ويسحب كل الأعضاء من رصيد olives نفسه. يمكن للمشرفين تعيين حدود إنفاق لكل عضو للتحكم في التكاليف.

يعرض سجل الفوترة والفواتير الإنفاق مفصلًا حسب العضو والمشروع. يمكنك رؤية أين ذهبت olives بالضبط.`,
  },
  'teams/models': {
    source_en_hash: 'v1:4buzhbqg6r',
    title: 'إدارة النماذج',
    description: 'تفعيل النماذج للفريق أو تعطيلها.',
    overview: `يمكن لمشرفي الفريق تفعيل نماذج ذكاء اصطناعي محددة أو تعطيلها. إذا كان نموذج ما مكلفًا أو غير موثوق لحالة استخدامك، فأوقفه. لن يراه أعضاء الفريق في منتقي النماذج.

هذا يحافظ على تركيز الواجهة وتوقع التكاليف. يمكنك تغيير قائمة النماذج في أي وقت من إعدادات الفريق.`,
  },
  'timeline/overview': {
    source_en_hash: 'v1:qfy9vuw7gs',
    title: 'نظرة عامة',
    description: 'جمّع اللقطات في تسلسل.',
    overview: `الجدول الزمني هو المكان الذي تتحول فيه اللقطات إلى تسلسل. اسحب اللقطات من الكانفاس إلى المسارات، ورتّبها، واقصّها، وعاين المونتاج. لا يحل محل Premiere أو DaVinci، لكنه كافٍ لبناء نسخة أولية، وفحص التوقيت، وتصدير حزمة للإكمال.

بدّل بين الكانفاس والجدول الزمني باستخدام مفتاح الوضع في شريط الأدوات. الكانفاس هو المكان الذي تولّد وتنظم فيه. والجدول الزمني هو المكان الذي تقص فيه.`,
  },
  'timeline/clips': {
    source_en_hash: 'v1:ha0n4cjv11',
    title: 'اللقطات والمسارات',
    description: 'أضف اللقطات إلى الجدول الزمني ورتّبها على المسارات.',
    overview: `اسحب لقطة من الكانفاس إلى الجدول الزمني لإضافتها إلى المونتاج. تلتصق لقطات الجدول الزمني ببعضها وبمؤشر التشغيل. قصّ بسحب أحد الحواف. يدعم الجدول الزمني أي عدد تحتاجه من المسارات.

ضع اللقطات فوق بعضها على مسارات مختلفة للتركيب. انقر بزر الفأرة الأيمن على لقطة في الجدول الزمني لرؤية خيارات مثل الحذف، وslip، وswap.`,
  },
  'timeline/audio': {
    source_en_hash: 'v1:1hlcrir9yjf',
    title: 'الصوت',
    description: 'الموجات الصوتية، والتعليق الصوتي، والموسيقى.',
    overview: `يوضع الصوت على مساراته الخاصة. استورد الصوت بسحب الملفات إلى الجدول الزمني أو من الكانفاس. تُعرض الموجات الصوتية inline حتى تتمكن من محاذاة القصات مع الإيقاعات أو الحوار.

تعمل مسارات التعليق الصوتي والموسيقى بالطريقة نفسها: أفلتها وحدد موضعها. النماذج التي تدعم توليد الصوت، مثل Veo 3، تنتج لقطات بصوت مدمج ينتقل إلى الجدول الزمني.`,
  },
  'timeline/playback': {
    source_en_hash: 'v1:pq7zgl6nne',
    title: 'التشغيل',
    description: 'عاين المونتاج بعناصر تحكم النقل.',
    overview: `يشغّل ||Space|| ويوقف مؤقتًا. تستخدم ||J||/||K||/||L|| للتنقل للخلف، والإيقاف، والأمام. يعرض مؤشر التشغيل الإطار الحالي في شاشة البرنامج.

عناصر التحكم نفسها في Premiere وAvid وDaVinci. تنتقل الذاكرة العضلية كما هي.`,
  },
  'timeline/sequences': {
    source_en_hash: 'v1:mlutts77ri',
    title: 'التسلسلات',
    description: 'نظّم المونتاج في مشاهد.',
    overview: `تتيح لك التسلسلات تقسيم الجدول الزمني إلى مشاهد. كل تسلسل مونتاج مستقل، وهذا مفيد عندما تريد العمل على مشاهد فردية قبل تجميع النسخة الكاملة.

بدّل بين التسلسلات للتركيز على أجزاء مختلفة من المشروع بدون فقدان السياق. فكّر فيها كبكرات أو فصول في مونتاج تقليدي.`,
  },
}
